// extracted by mini-css-extract-plugin
module.exports = {"withFlag":"antd-pro-components-country-flag-style-withFlag","flag":"antd-pro-components-country-flag-style-flag","label":"antd-pro-components-country-flag-style-label"};